<template>
  <section>
    <table class="w-100">
      <tr>
        <td style="width: 50%">
          <h2 class="report-name text-left">TOXICOLOGY REPORT</h2>
        </td>

        <td style="width: 50%">
          <div class="logo">
            <img
              :src="reportLogo"
              alt="logo"
              class="img-fluid sm-logo"
              style="max-height: 55px; max-width: 300px; float: right"
            />
          </div>
        </td>
      </tr>
    </table>
    <table class="w-100 address-information">
      <tr>
        <td>
          <p v-html="labAddress"></p>
          <p v-html="labAdministration"></p>
        </td>
      </tr>
    </table>
  </section>
</template>

<script>
import AppHelper from "@/mixins/AppHelper";
export default {
  props: ["reportsData"],
  data() {
    return {
      data: {},
      labAddress: "",
      labAdministration: "",
      reportLogo: "",
    };
  },
  mixins: [AppHelper],
  mounted() {
    this.setData();
  },
  methods: {
    setData() {
      let labDetails = this.reportsData ? this.reportsData.lab_details : {};
      if (labDetails && labDetails.address_line_1) {
        this.labAddress =
          (labDetails.name || "") +
          " &#9679; " +
          (labDetails.address_line_1 || "") +
          " &#9679; " +
          (labDetails.address_line_2 || "") +
          " &#9679; " +
          (labDetails.city || "") +
          " &#9679; " +
          (labDetails.state || "").toLowerCase() +
          " &#9679; " +
          (labDetails.zip || "") +
          " &#9679; " +
          "Phone:" +
          (labDetails.phone || "--") +
          " &#9679; " +
          " Fax: " +
          (labDetails.fax || "--");

        this.reportLogo = labDetails.logo;
      } else {
        this.labAddress =
          "MicroGen Health 14225 Sullyfield Circle, Suite E, Chantilly, Virginia 20151 Phone: +1 571-775-1974 Fax: 571-775-2012";
      }

      this.labAdministration =
        "Web: " +
        (labDetails.website || "--") +
        " &#9679; " +
        "CLIA #: " +
        (labDetails.clia_id || "--") +
        " &#9679; " +
        "Laboratory Director: " +
        (labDetails.director || "--") +
        "  ";
    },
  },
};
</script>

<style lang="scss" scoped>
.address-information {
  margin-top: 0;
  position: relative;
  text-align: center;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.25);
  p {
    line-height: 1.2;
    font-size: 14px;
    margin: 10px 0 0;
    font-weight: 400;
  }
}
</style>
